import { render, staticRenderFns } from "./BlogHome.vue?vue&type=template&id=2b4b6df3&scoped=true"
import script from "./BlogHome.vue?vue&type=script&lang=js"
export * from "./BlogHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b6df3",
  null
  
)

export default component.exports